package com.islamicmedia.shared.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * One recommended title on the result screen ("Alternatives" when the source is red/yellow,
 * "Similar Titles" when green). Always green (score >= 7) and the same media_type as the source.
 * Fetched live from GET /api/alternatives — never stored in AnalysisResult or history.
 */
@Serializable
data class AlternativeItem(
    val title: String,
    @SerialName("media_type") val mediaType: String,
    val year: String? = null,
    @SerialName("cover_url") val coverUrl: String? = null,
    val score: Int = 0,
    val similarity: Double = 0.0,
    val summary: String? = null
) {
    /** Convert to the shape the analyze trigger consumes when a card is tapped. */
    fun toDisambiguationItem(): DisambiguationItem = DisambiguationItem(
        title = title,
        year = year,
        mediaType = mediaType,
        coverUrl = coverUrl
    )
}

/**
 * GET /api/alternatives response. [status]:
 *   "ok"        — real green recommendations (1–5 items).
 *   "searching" — nothing yet; a background discovery job was kicked off (Phase 3).
 *   "none"      — nothing found and no job kicked off.
 *
 * [islamicItems] is the independent "More Islamic Picks" row — highest islamic_score same-type
 * titles. Populated regardless of [status]; may be non-empty even when [items] is empty.
 */
@Serializable
data class AlternativesResult(
    val status: String,
    val items: List<AlternativeItem> = emptyList(),
    @SerialName("islamic_items") val islamicItems: List<AlternativeItem> = emptyList(),
    @SerialName("author_items") val authorItems: List<AlternativeItem> = emptyList()
)
